import { Button, ButtonGroup, ButtonToolbar } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStepBackward, faStepForward } from '@fortawesome/free-solid-svg-icons';
import { NAVIGATION_ACTIONS } from './common';

// Toolbar component for calendar navigation and view switching
export const JobSchedulerToolbar = ({
    label, onNavigate, onView, view,
}) => (
    <ButtonToolbar className="mb-2 d-flex flex-row">
        <ButtonGroup size="sm">
            <Button
                color="outline-primary p-1"
                onClick={() => onNavigate(NAVIGATION_ACTIONS.PREVIOUS)}
            >
                <FontAwesomeIcon icon={faStepBackward} />
            </Button>
            <Button
                color="outline-primary p-1"
                onClick={() => onNavigate(NAVIGATION_ACTIONS.TODAY)}
            >
                <small>TODAY</small>
            </Button>
            <Button
                color="outline-primary p-1"
                onClick={() => onNavigate(NAVIGATION_ACTIONS.NEXT)}
            >
                <FontAwesomeIcon icon={faStepForward} />
            </Button>
        </ButtonGroup>

        <div className="rbc-toolbar-label d-flex flex-column flex-fill align-items-center justify-content-center">
            <strong>{label}</strong>
        </div>

        <ButtonGroup size="md">
            <Button
                color="outline-secondary"
                onClick={() => onView('month')}
                active={view === 'month'}
            >
                Month
            </Button>
            <Button
                color="outline-secondary"
                onClick={() => onView('agenda')}
                active={view === 'agenda'}
            >
                Agenda
            </Button>
        </ButtonGroup>
    </ButtonToolbar>
);
